
    import * as React from 'react';

    const Account24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.7533 19.3133C8.23038 20.3749 10.0422 21 12 21C13.9578 21 15.7696 20.3749 17.2467 19.3133C17.1401 16.2931 14.4665 13.75 12 13.75C9.53352 13.75 6.85992 16.2931 6.7533 19.3133ZM5.81594 18.5389C4.08186 16.8984 3 14.5755 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 14.5755 19.9181 16.8984 18.1841 18.5389C17.7237 15.2128 14.9228 12.75 12 12.75C9.07715 12.75 6.27631 15.2128 5.81594 18.5389ZM15.75 8.25C15.75 10.3211 14.0711 12 12 12C9.92893 12 8.25 10.3211 8.25 8.25C8.25 6.17893 9.92893 4.5 12 4.5C14.0711 4.5 15.75 6.17893 15.75 8.25ZM9.25 8.25C9.25 9.76878 10.4812 11 12 11C13.5188 11 14.75 9.76878 14.75 8.25C14.75 6.73122 13.5188 5.5 12 5.5C10.4812 5.5 9.25 6.73122 9.25 8.25Z" /></svg>
        </div>
      );
    };

    Account24.displayName = 'Account24';

    export default Account24;
  